<template>
  <div class="auth-login">
    <h1>関西調達検討会</h1>
    <b-container>
      <b-row align-h="center">
        <b-col md="8">
          <b-card header="ログイン">
            <b-form @submit.prevent="onSubmit">
              <b-form-group label="メールアドレス" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorEmail name="メールアドレス" :form="$v.email" nostate />
                </b-col>
              </b-form-group>

              <b-form-group label="パスワード" label-cols-md="4" label-align-md="right">
                <b-col md="9">
                  <FormValidatorPassword name="パスワード" :form="$v.password" nostate />
                </b-col>
              </b-form-group>

              <b-form-group>
                <b-col md="6" offset-md="4">
                  <b-button type="submit" variant="primary">ログイン</b-button>
                  <router-link to="forgot">パスワードを忘れた場合</router-link>
                </b-col>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, email, maxLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'AuthLogin',

  data() {
    return {
      email: '',
      password: '',
    };
  },

  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      maxLength: maxLength(72),
    },
  },

  methods: {
    onSubmit(evt) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store.dispatch('auth/login', {
        email: this.email,
        password: this.password,
        callback: (data) => {
          if (data.level > 0) {
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect, () => {}, () => {});
            } else {
              this.$router.push('/', () => {}, () => {});
            }
          }
        },
      });
    },
  },
};
</script>

<style scoped>
  .container {
  }
  .row {
  }
</style>
